const PATCH_NOTES_URL = 'https://api.hausperfekt.de/patch-notes?projectKey=AAR'

/**
 * Link auf die Patch-Notes im Datendienst. Nur der Beta-Build setzt
 * VITE_PATCH_NOTES_KEY; mit dem Schlüssel zeigt der Datendienst zusätzlich den Zug,
 * der gerade in der Beta ist (AAR-1996/AAR-1997). Der Parameter heißt bewusst
 * neutral `k`, damit Kunden in der Adresszeile keine „Beta" sehen.
 */
export function buildPatchNotesUrl(previewKey?: string | null): string {
	const key = previewKey?.trim()
	return key ? `${PATCH_NOTES_URL}&k=${encodeURIComponent(key)}` : PATCH_NOTES_URL
}

export const patchNotesUrl = buildPatchNotesUrl(
	import.meta.env?.VITE_PATCH_NOTES_KEY
)
